<template>
  <div class="box10">
    <pageTitle
      title="毕业起点高  职业发展广"
      text="产品经理岗位划分精细、择业范围广阔进入职场后的<br/>晋升之路清晰可见"
      titleColor="#191c47"
      titColor="#666666"
    />
    <div class="title">在职晋升空间</div>
    <div class="wrap">
      <div class="leftImg"></div>
      <div class="right">
        <div class="item" v-for="(item, index) in list" :key="index">
          <div class="post">
            {{ item.title }}
            <img
              v-if="item.special"
              src="../../../assets/coursePage/pm/box10/icon.png"
              alt=""
            />
          </div>
          <div class="box">
            <div class="after">
              平均薪资水平<span v-html="item.after"></span>
            </div>
            <div class="text">技能要求：{{ item.text }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="exp">
      * 以上数据来源：职场信息平台某准网2024年12月更新，仅供参考
    </div>
  </div>
</template>

<script>
import pageTitle from "../common/pageTitle.vue";
export default {
  components: {
    pageTitle,
  },
  data() {
    return {
      list: [
        {
          title: "产品专员/助理",
          after: " ¥8633 &nbsp;月收入中位数¥7670",

          text: "需求调研  需求分析 需求文档  原型设计",
        },
        {
          title: "中级产品经理",
          after: " ¥16813 &nbsp;月收入中位数¥12734",
          text: "需求调研  需求分析 原型设计 数据分析",
          special: true,
        },
        {
          title: "高级产品经理",
          after: " ¥27809 &nbsp;月收入中位数¥28524",
          text: "数据分析 用户研究 项目管理 产品规划",
        },
        {
          title: "产品总监",
          after: " ¥46592 &nbsp;月收入中位数¥49446",
          text: "产品规划 运营策略 数据分析",
        },
        {
          title: "企业CEO",
          after: "实现财富自由了 &nbsp;比如：伟大的产品人乔布斯",
          text: "运营策略  商业分析 市场战略 (信息数字化)",
        },
      ],
    };
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.box10 {
  padding: 80px 0 408px;
  background: url("../../../assets/coursePage/pm/box10/bgc.png") no-repeat;
  position: relative;
  background-size: cover;

  .title {
    background: url("../../../assets/coursePage/pm/box10/title.png") no-repeat;
    width: 244px;
    height: 68px;
    align-items: center;
    justify-content: center;
    font-size: 30px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #5f59ff;
    line-height: 68px;
    text-align: center;
    margin: 48px auto 32px;
    background-size: cover;
  }
  .wrap {
    display: flex;
    position: relative;
    margin-top: 48px;
    .leftImg {
      background: url("../../../assets/coursePage/pm/box10/arrow.png") no-repeat;
      width: 20px;
      height: 1122px;
      margin-left: 46px;
      background-size: cover;
    }
    .right {
      position: absolute;
      left: 32px;
      top: -10px;
      .item {
        margin-top: -1px;
        .post {
          display: flex;
          align-items: center;
          font-size: 28px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #191c47;
          line-height: 44px;
          margin-left: 48px;
          margin-bottom: 24px;
          img {
            margin-left: 16px;
            width: 160px;
            height: 50px;
          }
        }
        .box {
          margin-bottom: 41px;
          width: 686px;
          height: 160px;
          background: linear-gradient(180deg, #e7f5fe 0%, #ffffff 100%);
          box-shadow: 0px 4px 16px 0px rgba(115, 117, 245, 0.1);
          border-radius: 16px;
          border: 2px solid #ffffff;
          padding: 32px 0 0 48px;
          box-sizing: border-box;
          .after {
            font-size: 26px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #5c5594;
            line-height: 40px;
          }
          .text {
            font-size: 26px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #86909c;
            line-height: 40px;
            margin-top: 16px;
          }
        }
      }
      .item:nth-child(2) {
        .box {
          background: linear-gradient(180deg, #e8f3ff 0%, #ffffff 100%);
          box-shadow: 0px 4px 16px 0px rgba(115, 117, 245, 0.1);
        }
      }
      .item:nth-child(3) {
        .box {
          background: linear-gradient(180deg, #edf1ff 0%, #ffffff 100%);
          box-shadow: 0px 4px 16px 0px rgba(115, 117, 245, 0.1);
        }
      }
      .item:nth-child(4) {
        .box {
          background: linear-gradient(180deg, #ecebff 0%, #ffffff 100%);
          box-shadow: 0px 4px 16px 0px rgba(115, 117, 245, 0.1);
        }
      }
      .item:nth-child(5) {
        .box {
          padding-right: 48px;
          height: auto;
          background: linear-gradient(180deg, #e9e7ff 0%, #ffffff 100%);
          box-shadow: 0px 4px 16px 0px rgba(115, 117, 245, 0.1);
          .text {
            padding-bottom: 32px;
          }
        }
      }
    }
  }
  .exp {
    font-family: PingFang SC;
    font-size: 22px;
    font-weight: normal;
    font-stretch: normal;
    position: absolute;
    letter-spacing: 0px;
    color: rgba(140, 149, 178, 1);
    text-align: center;
    bottom: 88px;
    left: 50%;
    transform: translateX(-50%);
    width: 100%;
  }
}
</style>
